//ModalAddBeforeLawsuit
import {
  Button,
  Col,
  DatePicker,
  Divider,
  List,
  Modal,
  Row,
  Table,
  notification,
} from "antd";
import React, { useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { POST_ADD_ASSETTHASLOAN } from "../../../API/apiUrls";

function ModalAddBeforeLawsuit({
  open,
  close,
  selectedDistrict,
  handleChangDataForReturn,
}) {
  const [api, contextHolder] = notification.useNotification();
  const [filterDate, setFilterDate] = useState();
  const userId = localStorage.getItem("USER_ID");
  const [loading, setLoading] = useState(true);

  // console.log("selectedDistrict", selectedDistrict);

  const columns = [
    {
      title: "ชื่อ",
      align: "center",
      render: (value) => {
        // console.log("value", value);
        return (
          <>
            {value ? (
              <div style={{ textAlign: "start" }}>
                {value?.SNAM} {value?.NAME1} {value?.NAME2}
              </div>
            ) : null}
          </>
        );
      },
    },
    {
      title: "ที่อยู่",
      dataIndex: "asset",
      key: "asset",
      align: "center",
      render: (addresses) => {
        if (!addresses || addresses.length === 0) return null;
        // console.log("addresses", addresses);

        return (
          <div
            style={{
              // display: 'flex',
              flexDirection: "column",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "8px",
            }}
          >
            {addresses.map((addr, idx) => {
              // console.log("addr", addr);
              const addressText = addr ? (
                <>
                  {addr?.numberLand ? addr?.numberLand : ""}
                  {addr?.numberLandlawang ? addr?.numberLandlawang : ""}
                  {addr?.district ? addr?.district : ""}
                  {addr?.subdistrict ? addr?.subdistrict : ""}
                  {addr?.zipcode ? addr?.zipcode : ""}
                </>
              ) : (
                addr.address
              );

              const lat = addr.lat || null;
              const lng = addr.lng || null;

              return <span>{addressText}</span>;
            })}
          </div>
        );
      },
    },
    {
      title: "เบอร์โทร",
      dataIndex: "phone",
      key: "phone",
      align: "center",
      render: (record) => {
        // console.log("record", record);
        return (
          <>
            <div style={{ textAlign: "start" }}>
              {record === 0 ? <>คนกู้</> : <>คนค้ำ {record}</>}
            </div>
          </>
        );
      },
    },
    {
      title: "เกี่ยวข้องกับสัญญา",
      dataIndex: "role",
      key: "role",
      align: "center",
      render: (record) => {
        // console.log("record", record);
        return (
          <>
            <div style={{ textAlign: "start" }}>
              {record === 0 ? <>คนกู้</> : <>คนค้ำ {record}</>}
            </div>
          </>
        );
      },
    },
    {
      title: "สถานะสืบออนไลน์",
      dataIndex: "investigation",
      key: "investigation",
      align: "center",
      render: (value) => (value ? "เจอ" : "ไม่เจอ"),
    },
  ];

  const handdleClose = () => {
    close(false);
  };

  const handleSubmit = async () => {
    if (!filterDate) {
      api.warning({
        // message: 'คำเตือน',
        description: "กรุณาเลือกวันที่ลงพื้นที่",
        placement: "top",
      });
      return;
    }

    console.log("selectedDistrict", selectedDistrict);
    console.log("filterDate", filterDate);
    const dataMapforSet = selectedDistrict.map((item) => {
      console.log("item", item);
      return { ...item, dateRound: filterDate };
    });
    console.log("dataMapforSet", dataMapforSet);

    const UID = 888;
    const params = [
      {
        userId: UID,
        data: dataMapforSet, // เก็บ array ทั้งหมด
      },
    ];
    console.log("params", params);

    try {
      setLoading(true);
      const response = await axios.post(POST_ADD_ASSETTHASLOAN, params, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
        },
      });

      console.log("✅ API Response:", response.data); // 👈 log ข้อมูลที่ได้กลับมา
      // ✅ แสดงข้อความเมื่อสำเร็จ
      api.success({
        message: "สำเร็จ",
        description: "บันทึกข้อมูลเรียบร้อยแล้ว",
        placement: "top",
      });
      handdleClose();
      handleChangDataForReturn(true); // ส่งข้อมูลกลับไปยัง component หลัก
    } catch (error) {
      console.error("❌ API Error:", error);
      api.error({
        message: "เกิดข้อผิดพลาด",
        description: error.message,
        placement: "top",
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      // title="รายละเอียดที่เลือก"
      open={open} // แก้จาก visible เป็น open (AntD v5+)
      onCancel={handdleClose}
      width={900}
      footer={[
        <Button key="close" onClick={handdleClose}>
          ปิด
        </Button>,
        <Button key="save" type="primary" onClick={handleSubmit}>
          บันทึก
        </Button>,
      ]}
    >
      <Row justify="center" style={{ width: "900px" }}>
        <Col xs={24} sm={12}>
          <Divider type="vertical" style={{ margin: 4 }} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              lineHeight: "38px",
            }}
          >
            <span style={{ marginRight: "10px", fontSize: "18px" }}>
              <b>วันที่จะลงพื้นที่ : </b>
            </span>
            <DatePicker
              value={filterDate ? dayjs(filterDate) : null}
              onChange={(date) => {
                if (date) {
                  // แปลงเป็น ISO8601 เช่น 2025-08-26T00:00:00+07:00
                  setFilterDate(date.toISOString());
                } else {
                  setFilterDate(null);
                }
              }}
              style={{ width: "50%", height: "40px" }}
              placeholder="เลือกวันที่ลงสืบทรัพย์"
              // format="YYYY-MM-DD"
              allowClear
            />
          </div>
        </Col>

        <Col span={24}>
          <List
            style={{ width: "800px" }}
            dataSource={selectedDistrict} // ← ตอนนี้ selectedDistrict เป็น array ของ contracts แล้ว
            renderItem={(contract) => {
              console.log("contract", contract);

              return (
                <List.Item
                  style={{ flexDirection: "column", alignItems: "flex-start" }}
                >
                  <div style={{ marginBottom: 8 }}>
                    <strong>สัญญา: {contract.contno}</strong>
                    {/* | วันที่: {contract.date} */}
                  </div>
                  <Table
                    style={{ width: "800px" }}
                    dataSource={contract.customerList}
                    rowKey={(party) => party.name}
                    pagination={false}
                    bordered
                    size="small"
                    columns={columns}
                  />
                </List.Item>
              );
            }}
          />
        </Col>
      </Row>
      {contextHolder}
    </Modal>
  );
}

export default ModalAddBeforeLawsuit;
